/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState } from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import CkbPages from './CkbPages';
import arrowDown from './images/arrow_down_ckb.svg';
import arrowLeft from './images/arrow_left_ckb.svg';
import arrowRight from './images/arrow_right_ckb.svg';

function CustomerKnowlegeBase() {
  const [categories, setCategories] = useState([
    {
      title: 'Getting Started',
      descriptionLink1: 'Praesent aliquet nibh eget odio blandit finibus.',
      descriptionLink2: 'Praesent aliquet nibh eget.',
      descriptionLink3: 'Proin blandit dolor vitae.',
    },
    {
      title: 'Buying Guide',
      descriptionLink1: 'Proin blandit dolor vitae.',
      descriptionLink2: 'risus et quam blandit.',
      descriptionLink3: 'Proin blandit dolor vitae.',
    },
    {
      title: 'Selling Guide',
      descriptionLink1: 'Donec pulvinar turpis quis.',
      descriptionLink2: 'Praesent aliquet nibh eget.',
      descriptionLink3: 'Fusce in luctus mauris. ',
    },
  ]);
  const [ckbData, setCkbData] = useState([]);
  const [ckbChildData, setCkbchildData] = useState([]);
  const [breadCrumbHistory, setBreadCrumbHistoryHistory] = useState(JSON.parse(localStorage.getItem('breadCrumb')) || []);
  const [slugResponse, setSlugResponse] = useState([]);
  const [showSearchSlug, setShowSearchSlug] = useState(false);
  const [expand, setExpand] = useState(true);
  const [menuExpand, setMenuExpand] = useState(true);
  const [breadCrumbArray, setBreadCrumbArray] = useState([]);
  const [searchSuggestions, setSearchSuggestions] = useState([]);
  const [isNext, setIsNext] = useState(false);
  const [showCrumbsData, setShowCrumbsData] = useState(false);
  const [newId, setNewId] = useState();
  const [childId, setChildId] = useState();
  const [subHeadingId, setSubHeadingId] = useState();
  const [showSearchData, setShowSearchData] = useState(false);
  const [errors, setErrors] = useState('');
  const [searchIndex, setSearchIndex] = useState();
  const [contentData, setContentData] = useState([]);
  const [breadCrumbsData, setBreadCrumbsData] = useState([]);
  const childCkb = JSON.parse(localStorage.getItem('htmlfordisplay')) || {};
  const [allCkbChildData, setAllCkbChildData] = useState();
  const [itemData, setItemData] = useState({});
  const path = childCkb.title;
  const breadCrumbsPath = [
    {
      title: childCkb?.title,
      body: childCkb?.body,
      id: childCkb?.id,
      tags: childCkb?.tags || childCkb?.tagwise_data,
      slug: ckbChildData[newId]?.slug,
    },
  ];

  const showCrumbs = localStorage.getItem('showCrumbsData');
  const isNextPage = localStorage.getItem('isNext');
  const hrefData = `#${childId}`;
  const headingHref = `#${subHeadingId}`;
  const apiBaseUrl = process.env.REACT_APP_PRODUCTION_BASE_URL;

  const treeFilter = (item) => {
    const slugPath = window?.location?.href?.split('#')[1];
    const childs = item?.child || [];

    if (item.slug === slugPath || String(item.id) === slugPath) {
      setItemData(item);
    }

    for (const i of childs) {
      treeFilter(i);
    }
  };

  useEffect(() => {
    setBreadCrumbsData(JSON.parse(localStorage.getItem('htmlfordisplay')));
  }, [localStorage.getItem('htmlfordisplay')]);
  useEffect(() => {
    setContentData(JSON.parse(localStorage.getItem('content')));
  }, [localStorage.getItem('content')]);
  useEffect(() => {
    setAllCkbChildData(JSON.parse(localStorage.getItem('htmlfordisplay')) || {});
  }, [localStorage.getItem('htmlfordisplay')]);
  useEffect(() => {
    fetch(
      `${apiBaseUrl}/api/v2/pages/?type=cms.CustomPage&slug=customer-knowledgebase&fields=body`,
    )
      .then((response) => response?.json()).then((res) => {
        setCkbData(res?.items);
      }).catch((error) => {
        if (!errors) {
          setErrors(error);
        }
      });

    fetch(
      `${apiBaseUrl}/childcustompages/`,
    )
      .then((response) => (response?.json())).then((res) => {
        if (res.child) {
          const {
            title, body, tagwise_data, id, slug,
          } = res.child[0].child[0];
          const newData = {
            title,
            body,
            tags: tagwise_data,
            id,
            slug,
            parent_slug: slug,
          };
          treeFilter(res);
          const storedData = JSON.parse(localStorage.getItem('htmlfordisplay'));
          if (!storedData) {
            localStorage.setItem('htmlfordisplay', JSON.stringify(
              newData,
            ));
          }
          if (JSON.stringify(newData) !== JSON.stringify(storedData)) {
            localStorage.setItem('htmlfordisplay', JSON.stringify(
              newData,
            ));
          }
          setCkbchildData(res?.child);
        }
      }).catch((error) => {
        if (!errors) {
          setErrors(error);
        }
      });
  }, []);

  useEffect(() => {
    localStorage.setItem('htmlfordisplay', JSON.stringify(
      itemData,
    ));
  }, [itemData]);

  useEffect(() => {
    setSlugResponse(JSON.parse(localStorage.getItem('allCkbChilds')));
  }, [localStorage.getItem('allCkbChilds')]);

  const handleSearchBar = (e) => {
    const searhItem = e.target.value;
    if (searchIndex && !e.target) {
      setShowSearchData(false);
    }
    fetch(
      `${apiBaseUrl}/search/${searhItem}`,
    )
      .then((response) => (response?.json())).then((res) => {
        setSearchSuggestions(res);
      }).catch((error) => {
        if (!errors) {
          setErrors(error);
        }
      });
  };
  useEffect(() => {
    document.addEventListener('click', handleSearchBar, true);
    return () => {
      document.removeEventListener('click', handleSearchBar, true);
    };
  }, [showSearchData]);
  useEffect(() => {
    const unique = [...new Set(breadCrumbHistory?.map((item) => item?.title))];
    const checkSibling = breadCrumbArray.filter(
      (item) => item?.title !== ckbChildData[newId]?.title,
    );
    breadCrumbsPath?.forEach((x) => {
      if (breadCrumbHistory.find((d) => (
        checkSibling.length > 0 && checkSibling.find((dt) => dt?.title === d?.title)
      )) && ckbChildData.length > 0) {
        setBreadCrumbHistoryHistory([ckbChildData[newId]]);
        localStorage.setItem('breadCrumb', JSON.stringify([ckbChildData[newId]]));
        return null;
      }
      if (!unique.includes(x.title) && x.title) {
        setBreadCrumbHistoryHistory([...breadCrumbHistory, x]);
        localStorage.setItem('breadCrumb', JSON.stringify([...breadCrumbHistory, x]));
      }
    });
  }, [path]);
  const handleRouteIndex = (name, index) => {
    const breadCrumbsLinks = JSON.parse(localStorage.getItem('breadCrumb')) || [];
    breadCrumbsLinks.filter((routeName) => routeName !== name);
    const newHistory = breadCrumbHistory.splice(0, index);
    localStorage.setItem('breadCrumb', JSON.stringify(newHistory));
    setBreadCrumbHistoryHistory(newHistory);
    localStorage.setItem('allCkbChilds', JSON.stringify(name));
    localStorage.setItem('htmlfordisplay', JSON.stringify(name));
  };

  const handleRouteNewIndex = (name) => {
    localStorage.setItem('allCkbChilds', JSON.stringify(name));
    localStorage.setItem('htmlfordisplay', JSON.stringify(name));
  };
  const handleNext = () => {
    if (newId !== undefined) {
      if (newId !== undefined && ckbChildData.length - 1 !== newId) {
        setIsNext(true);
        const a = newId + 1;
        setNewId(a);
      }
    }
  };
  const handlePrevious = () => {
    if (newId !== 0) {
      setIsNext(true);
      const a = newId - 1;
      setNewId(a);
    }
  };
  const handleSearchSlug = (data) => {
    setSearchIndex(data.title);
    setShowSearchSlug(true);
    localStorage.setItem('searchBool', JSON.stringify(true));
    localStorage.setItem('allCkbChilds', JSON.stringify(data));
  };
  return (
    <div>
      <section className="section-style">
        <Breadcrumb className="">
          {breadCrumbHistory.length > 0 ? (
            <>
              <Breadcrumb.Item href="https://beta.palletfly.com/" className="breadcrumb-text" color="red">Home</Breadcrumb.Item>
              <Breadcrumb.Item
                className="breadcrumb-text"
                onClick={() => {
                  localStorage.removeItem('htmlfordisplay');
                  setBreadCrumbArray([]);
                  localStorage.removeItem('htmlforSlug');
                  setBreadCrumbArray([]);
                  setShowSearchSlug(false);
                  setShowSearchData(false);
                  setBreadCrumbHistoryHistory([]);
                  setShowCrumbsData(true);
                  localStorage.removeItem('breadCrumb');
                }}
                href="#"
              >
                Customer Knowledgebase
                {' '}
              </Breadcrumb.Item>
            </>
          ) : (
            <>
              <Breadcrumb.Item href="https://beta.palletfly.com/" className="breadcrumb-text" color="red">Home</Breadcrumb.Item>
              <Breadcrumb.Item
                className="breadcrumb-text"
                onClick={() => {
                  localStorage.removeItem('htmlfordisplay');
                  setBreadCrumbArray([]);
                  localStorage.removeItem('htmlforSlug');
                  setBreadCrumbArray([]);
                  setShowSearchSlug(false);
                  setShowSearchData(false);
                  setBreadCrumbHistoryHistory([]);
                  setShowCrumbsData(true);
                  localStorage.removeItem('breadCrumb');
                }}
                href="#"
              >
                Customer Knowledgebase
                {' '}
              </Breadcrumb.Item>
            </>
          )}
          {breadCrumbHistory && breadCrumbHistory.map((name, index) => {
            const isLast = index === breadCrumbHistory.length - 1;
            return isLast ? (
              <Breadcrumb.Item
                onClick={() => {
                  handleRouteNewIndex(name, index);
                  setShowCrumbsData(true);
                  localStorage.setItem('showCrumbsData', JSON.stringify(true));
                  localStorage.setItem('isNext', JSON.stringify(true));
                  setIsNext(false);
                }}
                key={ckbChildData[index]?.title}
                href={`#${name?.id}`}
              >
                <a href={`#${name?.id}`}>
                  {`${name?.title && name.title.charAt(0).toUpperCase() + name.title.slice(1)}`}
                </a>
              </Breadcrumb.Item>
            ) : (

              <Breadcrumb.Item className="breadcrumb-text" color="red">
                <a href={`#${name?.id}`}>
                  <button
                    type="button"
                    className="bg-body border-0 text-primary"
                    onClick={() => {
                      handleRouteIndex(name, index);
                      localStorage.setItem('showCrumbsData', JSON.stringify(true));
                      localStorage.setItem('isNext', JSON.stringify(true));
                      setShowCrumbsData(true);
                      setIsNext(false);
                    }}
                  >
                    {`${name?.title && name.title.charAt(0).toUpperCase() + name.title.slice(1)}`}
                  </button>
                </a>
              </Breadcrumb.Item>

            );
          })}
        </Breadcrumb>
        <div className="row">
          <div className="col-3 overflow-auto">
            <div className="">
              <div className="position-relative w-75">
                <input
                  id="nickname"
                  autoComplete="off"
                  placeholder="Search Topic"
                  value={searchIndex}
                  defaultValue={searchIndex}
                  onChange={(e) => {
                    handleSearchBar(e);
                    setSearchIndex(e.target.value);
                    setShowSearchData(true);
                    setIsNext(false);
                    setShowCrumbsData(false);
                  }}
                  className="form-control w-100 ckm-search-style mt-4 form-placeholder p-2 rounded-0"
                  name="WarehouseNickName"
                />
                {showSearchData && (
                  <div className={searchSuggestions.length > 1 ? 'search-prediction scrollbar-ckb border-0 overflow-auto' : 'search-prediction scrollbar-ckb border-0 h-auto overflow-auto'}>
                    {searchSuggestions?.slice(0, 5)?.map((data) => (
                      <button
                        type="button"
                        className="bg-body w-100 border-0 px-0 mx-0"
                        onClick={() => {
                          handleSearchSlug(data);
                          localStorage.setItem('showCrumbsData', JSON.stringify(true));
                          localStorage.setItem('isNext', JSON.stringify(true));
                          setShowCrumbsData(true);
                          setIsNext(false);
                        }}
                      >
                        <div className="border-start border-bottom border-end w-100 overflow-hidden px-0" style={{ maxHeight: '113px' }}>

                          <p className="text-start  w-100 mb-0 text-primary  mt-1 fs-5 px-2">{data.title}</p>
                          <hr className="dropdown-divider w-100 p-0 m-0" />
                          <div className=" px-2">
                            {/* eslint-disable-next-line react/no-danger */}
                            <span className="text-start w-100 mt-0 text-secondary" dangerouslySetInnerHTML={{ __html: data.body }} />
                          </div>
                        </div>
                      </button>
                    ))}
                  </div>
                )}
              </div>
              <div className="overflow-auto" style={{ height: '512px' }}>
                {childCkb.title && childCkb.body ? (
                  <>
                    <div className="d-flex">
                      <button className="bg-body border-0" type="button" onClick={() => setExpand(!expand)}>
                        <div className="d-flex">
                          <p className="mt-3">Table of Contents</p>
                          <img src={arrowDown} alt="no data" />
                        </div>
                      </button>
                    </div>
                    <div className="mx-2" style={{ display: expand ? 'block' : 'none' }}>
                      {/* eslint-disable-next-line react/no-danger */}
                      <a href={`#${allCkbChildData?.slug}`} className="">
                        <span className="text-primary">{allCkbChildData?.title}</span>
                      </a>
                      {allCkbChildData?.tags ? (
                        <div>
                          {allCkbChildData?.tags?.map((headings) => (
                            <a href={headingHref}>
                              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
                              <p
                                type="button"
                                className="bg-body mb-0 text-start border-0"
                                onClick={() => {
                                  setSubHeadingId(headings.id);
                                  setShowCrumbsData(false);
                                  localStorage.setItem('showCrumbsData', JSON.stringify(false));
                                  localStorage.setItem('isNext', JSON.stringify(false));
                                }}
                              >
                                {/* eslint-disable-next-line react/no-danger */}
                                {/* eslint-disable-next-line no-nested-ternary */}
                                {headings?.tag === 'h2' ? (
                                  <p
                                    className="mb-0 text-primary"
                                    style={{
                                      paddingLeft: headings?.tag === 'h2' ? '20px' : '',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      maxWidth: '50ch',
                                    }}
                                  >
                                    {(headings.text)?.split(':')}
                                  </p>
                                ) : (
                                  // eslint-disable-next-line no-nested-ternary
                                  headings?.tag === 'h3' ? (
                                    <p
                                      className="mb-0 text-primary"
                                      style={{
                                        paddingLeft: headings?.tag === 'h3' ? '50px' : '',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '50ch',
                                      }}
                                    >
                                      {(headings.text)?.split(':')}
                                    </p>
                                  ) : (
                                    headings?.tag === 'h4' ? (
                                      <p
                                        className="mb-0 text-primary"
                                        style={{
                                          paddingLeft: headings?.tag === 'h4' ? '70px' : '',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          maxWidth: '50ch',
                                        }}
                                      >
                                        {(headings.text)?.split(':')}
                                      </p>
                                    ) : (null)
                                  ))}
                              </p>
                            </a>
                          ))}
                        </div>
                      ) : (
                        <div>
                          {allCkbChildData?.tagwise_data?.map((headings) => (
                            <a href={headingHref}>
                              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
                              <p
                                type="button"
                                className="bg-body mb-0 text-start border-0"
                                onClick={() => {
                                  setSubHeadingId(headings.id);
                                  setShowCrumbsData(false);
                                  console.log(headings);
                                  localStorage.setItem('showCrumbsData', JSON.stringify(false));
                                  localStorage.setItem('isNext', JSON.stringify(false));
                                }}
                              >
                                {/* eslint-disable-next-line react/no-danger */}
                                {/* eslint-disable-next-line no-nested-ternary */}
                                {headings?.tag === 'h2' ? (
                                  <p
                                    className="mb-0 text-primary"
                                    style={{
                                      paddingLeft: headings?.tag === 'h2' ? '20px' : '',
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      maxWidth: '50ch',
                                    }}
                                  >
                                    {(headings.text)?.split(':')}
                                  </p>
                                ) : (
                                  // eslint-disable-next-line no-nested-ternary
                                  headings?.tag === 'h3' ? (
                                    <p
                                      className="mb-0 text-primary"
                                      style={{
                                        paddingLeft: headings?.tag === 'h3' ? '50px' : '',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        maxWidth: '50ch',
                                      }}
                                    >
                                      {(headings.text)?.split(':')}
                                    </p>
                                  ) : (
                                    headings?.tag === 'h4' ? (
                                      <p
                                        className="mb-0 text-primary"
                                        style={{
                                          paddingLeft: headings?.tag === 'h4' ? '70px' : '',
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          maxWidth: '50ch',
                                        }}
                                      >
                                        {(headings.text)?.split(':')}
                                      </p>
                                    ) : (null)
                                  ))}
                              </p>
                            </a>
                          ))}
                        </div>
                      )}
                    </div>
                  </>
                ) : null}
                {ckbChildData.length > 0 && (
                  <div>
                    {!childCkb.title && !childCkb.body ? (
                      <div className="mt-5">
                        <div className="d-flex w-100">
                          <p className="mt-3">Recommended Topics</p>
                          {childCkb.title && childCkb.body ? (
                            <img src={arrowDown} alt="no data" />
                          ) : null}
                        </div>
                        {ckbChildData?.slice(0, 9)?.map((d, id) => (
                          <div className="mx-1" style={{ display: menuExpand ? 'flex' : 'none' }}>
                            <div className="">
                              {id + 1}
                              .
                            </div>
                            <div>
                              <a href={hrefData}>
                                <CkbPages
                                  child={d}
                                  id={id}
                                  setGetId={() => {
                                    setNewId(id);
                                  }}
                                  handleHTML={(htmlfordisplay) => {
                                    setChildId(htmlfordisplay.slug);
                                    const array = [];
                                    array.push(d);
                                    setIsNext(false);
                                    setShowSearchSlug(false);
                                    localStorage.setItem('content', JSON.stringify(array));
                                    localStorage.setItem('htmlforSlug', JSON.stringify({
                                      slug: htmlfordisplay.slug,
                                      parent_slug: htmlfordisplay?.slug,
                                    }));
                                    setBreadCrumbArray(ckbChildData);
                                    localStorage.setItem('htmlfordisplay', JSON.stringify({
                                      title: htmlfordisplay.title,
                                      body: htmlfordisplay.body,
                                      tags: htmlfordisplay.tagwise_data,
                                      id: htmlfordisplay.id,
                                      slug: htmlfordisplay.slug,
                                      parent_slug: htmlfordisplay?.slug,
                                    }));
                                    setShowCrumbsData(false);
                                    localStorage.setItem('showCrumbsData', JSON.stringify(false));
                                    localStorage.setItem('isNext', JSON.stringify(false));
                                  }}
                                />
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="mt-5">
                        <button className="bg-body mb-3 text-start d-flex border-0" style={{ height: '20px' }} type="button" onClick={() => setMenuExpand(!menuExpand)}>
                          <div className="d-flex w-10">
                            <p className="mt-3">Menu</p>
                            {childCkb.title && childCkb.body ? (
                              <img src={arrowDown} alt="no data" />
                            ) : null}
                          </div>
                        </button>

                        {ckbChildData?.map((d, id) => (
                          <div className="mx-1" style={{ display: menuExpand ? 'flex' : 'none' }}>
                            <div>
                              {id + 1}
                              .
                            </div>
                            <div>
                              <a href={hrefData}>
                                <CkbPages
                                  child={d}
                                  id={id}
                                  setGetId={() => {
                                    setNewId(id);
                                  }}
                                  handleHTML={(htmlfordisplay) => {
                                    setChildId(htmlfordisplay.slug);
                                    const array = [];
                                    array.push(d);
                                    setIsNext(false);
                                    setShowSearchSlug(false);
                                    localStorage.setItem('content', JSON.stringify(array));
                                    localStorage.setItem('htmlforSlug', JSON.stringify({
                                      slug: htmlfordisplay.slug,
                                      parent_slug: htmlfordisplay?.slug,
                                    }));
                                    setBreadCrumbArray(ckbChildData);
                                    localStorage.setItem('htmlfordisplay', JSON.stringify({
                                      title: htmlfordisplay.title,
                                      body: htmlfordisplay.body,
                                      tags: htmlfordisplay.tagwise_data,
                                      id: htmlfordisplay.id,
                                      slug: htmlfordisplay.slug,
                                      parent_slug: htmlfordisplay?.slug,
                                    }));
                                    setShowCrumbsData(false);
                                    localStorage.setItem('showCrumbsData', JSON.stringify(false));
                                    localStorage.setItem('isNext', JSON.stringify(false));
                                  }}
                                />
                              </a>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col">
            <div className="overflow-scroll scrollbar-ckb">
              {!childCkb.title && !childCkb.body && !showSearchSlug ? (
                <div>
                  {ckbData?.map((data) => (
                    <>
                      <h2 className="text-start mt-5 fw-bold display-5">
                        {data.title}
                      </h2>
                      {/* eslint-disable-next-line react/no-danger */}
                      <div className="mt-5" dangerouslySetInnerHTML={{ __html: data.body }} />
                    </>
                  ))}
                  <div className="mt-5 mb-5">
                    <h6 className="text-start popular-category-text fs-2">POPULAR CATEGORIES</h6>
                    <div className="row mx-1 mt-5">
                      {categories?.map((category) => (
                        <div className="col-3 pt-2 mx-2 border">
                          <p className="fs-5 ckm-category-text">{category.title}</p>
                          <div className="mx-3">
                            <p className="mb-0 ckm-category-text">
                              <Link to="/">
                                {category.descriptionLink1}
                              </Link>
                            </p>
                            <p className="mb-2 ckm-category-text">
                              <Link to="/">{category.descriptionLink2}</Link>
                            </p>
                            <p className="mb-4 ckm-category-text">
                              <Link to="/">{category.descriptionLink2}</Link>
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <div>

                  {showSearchSlug ? (
                    <>
                      <h2 className="text-start mt-5 fw-bold display-5">
                        {slugResponse?.title}
                      </h2>
                      {/* eslint-disable-next-line react/no-danger */}
                      <div className="mt-5" dangerouslySetInnerHTML={{ __html: slugResponse?.body }} />
                    </>
                  ) : (
                    <div>
                      {showCrumbs && showCrumbsData ? (
                        <div>
                          {breadCrumbsData?.tags ? (
                            <div>
                              {/* eslint-disable-next-line react/no-danger */}
                              <h2 id={breadCrumbsData?.id} className="text-start mt-5 fw-bold display-5" dangerouslySetInnerHTML={{ __html: breadCrumbsData?.title }} />
                              {/* eslint-disable-next-line react/no-danger */}
                              {breadCrumbsData?.tags?.map((childs) => (
                                <>
                                  {/* eslint-disable-next-line react/no-danger */}
                                  <div id={childs?.id} className="mt-5" dangerouslySetInnerHTML={{ __html: childs?.tagbody }} />
                                </>
                              ))}
                            </div>
                          ) : (
                            <div>
                              {/* eslint-disable-next-line react/no-danger */}
                              <h2 id={breadCrumbsData?.id} className="text-start mt-5 fw-bold display-5" dangerouslySetInnerHTML={{ __html: breadCrumbsData?.title }} />
                              {/* eslint-disable-next-line react/no-danger */}
                              {breadCrumbsData.tagwise_data?.map((childs) => (
                                <>
                                  {/* eslint-disable-next-line react/no-danger */}
                                  <div id={childs?.id} className="mt-5" dangerouslySetInnerHTML={{ __html: childs?.tagbody }} />
                                </>
                              ))}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div>
                          {isNext && isNextPage ? (
                            <div>
                              <div>
                                {/* eslint-disable-next-line react/no-danger */}
                                <h2 className="text-start mt-5 fw-bold display-5" dangerouslySetInnerHTML={{ __html: ckbChildData[newId]?.title }} />
                                {ckbChildData[newId]?.tagwise_data?.map((child) => (
                                  <>
                                    {/* eslint-disable-next-line react/no-danger */}
                                    <div className="mt-5" dangerouslySetInnerHTML={{ __html: child?.tagbody }} />
                                  </>
                                ))}
                              </div>
                            </div>
                          ) : (
                            <div>
                              {allCkbChildData?.tags ? (
                                <div>
                                  {/* eslint-disable-next-line react/no-danger */}
                                  <h2 id={allCkbChildData?.id} className="text-start mt-5 fw-bold display-5" dangerouslySetInnerHTML={{ __html: allCkbChildData?.title }} />
                                  {allCkbChildData?.tags?.map((childs) => (
                                    <>
                                      {/* eslint-disable-next-line react/no-danger */}
                                      <div id={childs?.id} className="mt-5 text-start" dangerouslySetInnerHTML={{ __html: childs?.tagbody }} />
                                    </>
                                  ))}
                                </div>
                              ) : (
                                <div>
                                  {/* eslint-disable-next-line react/no-danger */}
                                  <h2 id={allCkbChildData?.id} className="text-start mt-5 fw-bold display-5" dangerouslySetInnerHTML={{ __html: allCkbChildData?.title }} />
                                  {allCkbChildData?.tagwise_data?.map((childs) => (
                                    <>
                                      {/* eslint-disable-next-line react/no-danger */}
                                      <div id={childs?.id} className="mt-5 text-start" dangerouslySetInnerHTML={{ __html: childs?.tagbody }} />
                                    </>
                                  ))}
                                </div>
                              )}

                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  )}

                </div>
              )}

            </div>
            <div className="w-100 mt-3 d-flex justify-content-between">
              {!showCrumbsData && localStorage.getItem('showCrumbsData', JSON.stringify(false)) && ckbChildData[newId]?.title && (
                <>
                  <button
                    type="button"
                    className="ckb-next-btn"
                    onClick={() => handlePrevious()}
                    disabled={newId === 0}
                  >
                    <img className={newId !== 0 ? 'opacity-100 mb-1' : 'ckb-next-img mb-1'} src={arrowLeft} alt="no data" />
                    Prev. Topic
                    {' '}
                    -
                    {ckbChildData[newId - 1]?.title}
                    {' '}

                  </button>

                  <button
                    className="ckb-next-btn"
                    type="button"
                    onClick={() => handleNext()}
                    disabled={ckbChildData.length - newId === 1}
                  >
                    {ckbChildData[newId + 1]?.title}
                    {' '}
                    -
                    Next Topic
                    <img className={ckbChildData[newId + 1]?.title ? ' opacity-100' : 'ckb-next-img'} src={arrowRight} alt="no data" />
                  </button>
                </>
              )}
            </div>
          </div>
        </div>

      </section>
    </div>
  );
}

export default CustomerKnowlegeBase;
